import * as svg from "../../../assets/disabled-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const DisabledIcon = iconBuilder(svg, "DisabledIcon", "0 0 10 11");
